import { AlertDialog } from 'components'
import { Form } from 'modules/orders/components'
import { useCreateOrder } from 'modules/orders/hooks/useCreateOrder'
import { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'

import { useNavigate, useSearchParams } from 'react-router-dom'
import { useOrderStore } from 'modules/orders/store'
import { useSendToReview } from 'modules/orders/hooks'
import { useLayoutContext } from 'layout/layout.context'

export const CreateOrderPage = () => {
  const queryClient = useQueryClient()
  const [openAlert, setOpenAlert] = useState(false)
  const [proposalId, setProposalId] = useState('')
  const [searchParams] = useSearchParams()
  const [opportunityId] = useState(searchParams.get('opportunityId'))
  const navigate = useNavigate()
  const { setBreadcrumbs } = useLayoutContext()

  const setForm = useOrderStore.useSetForm()
  const resetForm = useOrderStore.useResetForm()
  const setCurrentStep = useOrderStore.useSetCurrentStep()

  const { mutateAsync, isLoading } = useCreateOrder()
  const { mutate: sendToReview } = useSendToReview()

  useEffect(() => {
    setBreadcrumbs([
      { label: 'Início', to: '/home' },
      { label: 'Pedidos', to: '/orders' },
      { label: 'Novo Orçamento' }
    ])
    return () => setBreadcrumbs([])
  }, [])

  const handleSubmit = async (data: any) => {
    const response = await mutateAsync(data)

    if (response?.data?.approvalNeeded) {
      console.log('response', response?.data?.approvalNeeded)

      setOpenAlert(true)
      setProposalId(response?.data?.proposalId)
    }

    navigate('/orders')
  }

  const handleAlertClose = (ok: boolean) => {
    if (ok) {
      console.log('ok', ok)
      sendToReview({ proposalId })
    }
    navigate('/orders')
  }

  useEffect(() => {
    resetForm()
    setCurrentStep('general')
    setForm({
      deliveryDate: new Date().toISOString(),
      paymentResponsible: null
    })
    queryClient.invalidateQueries()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (opportunityId) {
      setForm({ opportunity: { id: opportunityId } })
    }
  }, [opportunityId, setForm])

  return (
    <>
      <Form handleSubmit={handleSubmit} isSubmitting={isLoading} />
      {openAlert && (
        <AlertDialog
          open={openAlert}
          text="Deseja enviar para análise do supervisor?"
          title="Pedido possui quesitos a serem analisados"
          onClose={handleAlertClose}
          okButtonLabel="enviar"
          cancelButtonLabel="não"
        />
      )}
    </>
  )
}

export default CreateOrderPage
